import '../../assets/css/register.css';

import { Component } from 'react';

import { withRouter } from "react-router-dom";
import api from "../../lib/api";
import { setItem, getItem, KEY } from "../../lib/database";
import { getJSONFromUrl, navigateTo, showNotification, isDesktop, isMobile } from "../../lib/helper";
import { connect } from "react-redux";
import { updateAppConfigAction, fetchingUserSuccess } from "../../redux/actions"
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import { useSnackbar } from "notistack";
class Register extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			username: '',
			ref_username: '',
			ref_username_disabled: false,
			is_show_password: false,
			email_address: getJSONFromUrl().email || '',
			countDown: 30,
			is_email_send: false,
			is_verify: 0,
		};
		this.countDownInterval = null;
	}

	onChangeInput = (type) => (e) => {
		this.setState({ [type]: e.target.value });
	}

	componentDidMount() {
		let { r } = getJSONFromUrl();
		if (r) {
			setItem(KEY.REF_USERNAME, r);
		} else {
			r = getItem(KEY.REF_USERNAME);
		}
		this.setState({ ref_username: r, ref_username_disabled: !!r });
	}
	componentDidUpdate(prevProps) {
		let { is_email_verified } = this.props.memberReducer;
		if (is_email_verified === 1 && this.state.is_verify !== 1) {
			this.setState({ is_verify: 1 });
		}
	}
	onKeyPress = (e) => {
		if (e.code === 'Enter') {
			this.onSignUp(e);
		}
	}
	onSignUp = (e) => {
		e.preventDefault();
		let { email, password, username, ref_username } = this.state;
		let { is_show_login } = this.props.appReducer;
		let { enqueueSnackbar } = this.props;
		let isDisableSignButton = !email || email.length === 0 || !password || password.length === 0 || !username || username.length === 0;
		if (isDisableSignButton) {
			return false;
		}

		api.register({ email, password, username, ref_username }).
			then(({ data, message, success }) => {
				if (!success) {
					showNotification(enqueueSnackbar, { message, type: 'danger' });
					return;
				}
				if (this.state.countDown == 0) {
					this.setState({ countDown: 30 });
				}
				let is_login_first = true;
				api.login({ email, password, is_login_first })
					.then(({ data, message, success }) => {
						if (!success) {
							showNotification(enqueueSnackbar, { message, type: 'danger' });
							return;
						}
						this.props.fetchingUserSuccess(data);
						// this.props.history.push('/login');
						this.sendEmail();
					});
			})
	}
	sendEmail = () => {
		let { enqueueSnackbar } = this.props;
		this.setState({ is_email_send: true });
		this.countDownEmail();
		api.sendVerificationEmail().then(({ message }) => {
			if (message !== 'Verification email sent successfully') {
				showNotification(enqueueSnackbar, { message, type: 'error' });
				return;
			}
			showNotification(enqueueSnackbar, { message, type: 'success' });
		})
	}
	onSetLogin = (type) => (e) => {
		e.preventDefault();
		navigateTo("/login").bind(this)(e);
	}
	close = (e) => {
		navigateTo("/").bind(this)(e);
	}
	onToggleShowPassword = () => {
		this.setState({ is_show_password: !this.state.is_show_password })
	}

	onPreventUsername = (e) => {
		if (!e.key.match(/[a-zA-Z0-9,]/)) {
			e.preventDefault();
		}
	}
	// sendVerificationEmail = (e) => {
	// 	e.preventDefault();
	// 	api.sendVerificationEmail()
	// }
	// async sendVerificationEmail(e) {
	// 	e.preventDefault();
	// 	let { email, password, username } = this.state;
	// 	await api.sendVerificationEmail({ email, username, password }).then(({ message }) => {
	// 		if (message === "Verification email sent.") {
	// 			this.setState({ is_email_send: true });
	// 		}
	// 	});
	// };
	countDownEmail = (e) => {
		if (this.countDownInterval) {
			clearInterval(this.countDownInterval);
		}
		// Set a new interval
		this.countDownInterval = setInterval(() => {
			let { countDown } = this.state;
			if (countDown === 0) {
				clearInterval(this.countDownInterval); // Clear the interval when countDown reaches 0
				return;
			}
			this.setState({ countDown: countDown - 1 });
		}, 1000);
	}
	openMail = (e) => {
		e.preventDefault();
		let { email } = this.state;
		window.open(`https://mail.google.com/mail/u/0/#inbox`);
	}
	onChangeUsername = (e) => {
		let username = (e.target.value || '')
			.toLowerCase()
			.replace(/[.-]/g, '')
			.replace(/[^\w ]+/g, '')
			.replace(/ +/g, '');
		this.setState({ username: username });
	}

	render() {
		let { t } = this.props;
		let { email, password, username, is_verify, ref_username, ref_username_disabled, is_show_password, countDown, is_email_send } = this.state;
		let isDisableSignButton = !email || email.length === 0 || !password || password.length === 0 || !username || username.length === 0;
		let { asset_logo } = this.props.appReducer;
		// let { is_verify } = this.props.memberReducer;
		return (
			<div data-v-682ccdfa="" data-v-b0e45e8c="" className="boxFix">
				<div data-v-682ccdfa="" className="boxAuthentication show">
					<div data-v-682ccdfa=""
						className={`contentAuthentication d-flex flex-column align-items-center`}
						style={{ position: 'fixed', width: isDesktop() ? '500px' : '100%', right: '0', padding: '170px , 150px ,0px , 150px' }}>
						<div data-v-682ccdfa=""
							className="header  position-absolute px-3 d-flex align-items-center justify-content-between w-100"><a
								style={{ backgroundImage: 'url(/images/logo-main.png?ver=1182835)', backgroundSize: 'cover' }}
								data-v-682ccdfa="" href="/login" className="logoLogin mb-0 router-link-active">BONAX</a>
							<div data-v-f99ecb42="" onClick={this.close} className="close-page">
								<span data-v-f99ecb42="" className="pe pe-7s-close" />
							</div>
						</div>
						<div data-v-682ccdfa="" className="formWapper w-100 py-lg-5 px-lg-2 pt-0 h-auto" style={{ marginTop: isMobile() ? '5rem' : '' }}>
							{!is_email_send && <form data-v-682ccdfa="" className="mt-5"><h2 data-v-682ccdfa=""
								className={`mt-5 color-white font-weight-bold mb-lg-4 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>{t('CreateBonaxAccount')}</h2>
								<div data-v-682ccdfa=""
									className="md-field md-theme-default md-has-placeholder"><label
										data-v-682ccdfa="" htmlFor="md-input-l82oqjdho" className='text-white font-16'>
										{t('EmailAddress')}
										<small data-v-682ccdfa="">*</small></label> <input data-v-682ccdfa=""
											type="text"
											value={email || ""}
											onKeyPress={this.onKeyPress}
											onChange={this.onChangeInput('email')}
											id="md-input-l82oqjdho"
											placeholder={t('InputEmail')}
											className="md-input background-2F3241" />
									<small data-v-682ccdfa=""
										className="md-error" />   </div>
								<div data-v-682ccdfa=""
									className="md-field md-theme-default md-has-placeholder md-has-password"
									md-has-password=""><label className='text-white font-16' data-v-682ccdfa="" htmlFor="md-input-j4h4qfszm">
										{t('Password')}
										<small data-v-682ccdfa="">*</small></label> <input data-v-682ccdfa=""
											type={is_show_password ? 'text' : 'password'}
											value={password || ""}
											onKeyPress={this.onKeyPress}
											onChange={this.onChangeInput('password')}
											id="md-input-j4h4qfszm"
											placeholder={t('InputPassword')}
											maxLength="20"
											className="md-input background-2F3241" />
									<small data-v-682ccdfa="" className="md-error" /> <span
										className="md-count">{password.length} / 20</span>
									<button type="button"
										onClick={this.onToggleShowPassword}
										className="md-button md-icon-button md-dense md-input-action md-toggle-password md-theme-default"
										tabIndex="-1">
										<div className="md-ripple">
											<div className="md-button-content">
												<i className="md-icon md-icon-font md-icon-image md-theme-default">
													{is_show_password ?
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width={20}
															height={21}
															fill="none"
														>
															<path
																fill="#E5E6ED"
																d="M17.696 8.948C16.602 7.116 14.146 4.042 10 4.042S3.4 7.116 2.304 8.948a3.019 3.019 0 0 0 0 3.104C3.4 13.884 5.854 16.958 10 16.958s6.602-3.074 7.696-4.906a3.019 3.019 0 0 0 0-3.104Zm-1.072 2.462c-.959 1.605-3.094 4.298-6.624 4.298-3.529 0-5.665-2.692-6.623-4.298a1.775 1.775 0 0 1 0-1.82c.958-1.606 3.094-4.3 6.623-4.3 3.53 0 5.665 2.693 6.624 4.3.335.562.335 1.258 0 1.82ZM10 6.958A3.546 3.546 0 0 0 6.46 10.5 3.546 3.546 0 0 0 10 14.042a3.546 3.546 0 0 0 3.542-3.542A3.546 3.546 0 0 0 10 6.958Zm0 5.834A2.294 2.294 0 0 1 7.71 10.5 2.294 2.294 0 0 1 10 8.208a2.294 2.294 0 0 1 2.292 2.292A2.294 2.294 0 0 1 10 12.792Z"
															/>
														</svg>
														: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M15.8387 10.9576L17.1878 12.9876C17.3787 13.2751 17.3004 13.6634 17.0129 13.8543C16.9062 13.9251 16.787 13.9584 16.6678 13.9584C16.4653 13.9584 16.267 13.8601 16.1462 13.6793L14.8469 11.7252C14.2103 12.1502 13.4603 12.5117 12.5878 12.7626L13.1062 14.8494C13.1904 15.1844 12.9853 15.5235 12.6503 15.6068C12.5994 15.6193 12.5495 15.6251 12.4987 15.6251C12.2187 15.6251 11.9628 15.435 11.8928 15.1509L11.3645 13.0226C10.932 13.0826 10.4837 13.1251 9.99951 13.1251C9.51534 13.1251 9.06706 13.0826 8.63456 13.0226L8.1062 15.1509C8.0362 15.435 7.78032 15.6251 7.50032 15.6251C7.44949 15.6251 7.39959 15.6193 7.34875 15.6068C7.01375 15.5235 6.80949 15.1844 6.89282 14.8494L7.41121 12.7626C6.53955 12.5109 5.78856 12.1493 5.15189 11.7252L3.85286 13.6793C3.73203 13.8601 3.53372 13.9584 3.33122 13.9584C3.21205 13.9584 3.09283 13.9243 2.98616 13.8543C2.69866 13.6634 2.6212 13.2751 2.8112 12.9876L4.16028 10.9576C2.51778 9.45839 1.91607 7.7285 1.90523 7.69767C1.79607 7.37017 1.97365 7.01602 2.30115 6.90685C2.63198 6.79769 2.98198 6.97512 3.09114 7.30012C3.12948 7.41262 3.71372 9.04169 5.31872 10.325C5.32206 10.3267 5.32538 10.3268 5.32788 10.3293C5.33621 10.3351 5.34113 10.3442 5.34863 10.35C6.4103 11.1892 7.90955 11.8743 9.99788 11.8743C12.0862 11.8743 13.5853 11.1884 14.6469 10.35C14.6553 10.3442 14.6596 10.3343 14.6679 10.3293C14.6712 10.3276 14.6745 10.3275 14.677 10.325C16.282 9.04169 16.8661 7.41262 16.9044 7.30012C17.0161 6.97346 17.3704 6.80017 17.6962 6.90767C18.0229 7.01767 18.1987 7.37019 18.0903 7.69685C18.0828 7.72852 17.4812 9.45922 15.8387 10.9576Z" fill="#E5E6ED" />
														</svg>
													}
												</i>
											</div>
										</div>
									</button></div>
								<div data-v-682ccdfa=""
									className="md-field md-theme-default md-has-placeholder nickName"><label
										data-v-682ccdfa="" className='text-white font-16' htmlFor="md-input-31z20oa47">
										{t('Nickname')}
										<small data-v-682ccdfa="">*</small></label> <input data-v-682ccdfa=""
											type="text"
											autoComplete={'off'}
											value={username || ""}
											onKeyDown={this.onPreventUsername}
											onKeyPress={this.onKeyPress}
											onChange={this.onChangeUsername}
											id="md-input-31z20oa47"
											placeholder={t('InputNickname')}
											maxLength="20"
											className="md-input background-2F3241" />
									<span className="md-count">{username.length} / 20</span>
								</div>
								<div data-v-682ccdfa=""
									className="md-field md-theme-default md-has-placeholder nickName"><label
										data-v-682ccdfa="" className='text-white font-16' htmlFor="md-input-31z20oa47">{t('ReferralCode')}</label>
									<input data-v-682ccdfa=""
										type="text"
										autoComplete={'off'}
										value={ref_username || ""}
										onKeyPress={this.onKeyPress}
										disabled={ref_username_disabled}
										onChange={this.onChangeInput('ref_username')}
										id="md-input-31z20oa47"
										placeholder={t('InputRefererCode')}
										className="md-input background-2F3241" />
								</div>
								<p data-v-682ccdfa="" className="text-center ">
									<button data-v-f99ecb42="" type='button' onClick={this.onSignUp} disabled={isDisableSignButton}
										className={'w-100 mt-4 ' + (isDisableSignButton ? 'btn-secondary btn' : 'btnheader log-in-under d-flex justify-content-center align-items-center text-white font-16')}>{t('Register')}</button>
								</p>
							</form>}
							{is_email_send && is_verify === 0 && <form className="loginForm d-flex flex-column justify-content-center h-100 colorWhite">
								<h2 className={`mt-5 color-white font-weight-bold mb-lg-5 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>Đăng ký thành công</h2>
								<div data-v-f99ecb42=""
									className="md-field md-theme-default md-has-placeholder">
									<p><span className='mr-1'>Một liên kết xác nhận đã được gửi tới</span><a href='' onClick={this.openMail} className='colorBlue4'>{email}</a>.</p>
									<p className='mt-3'>Vui lòng chờ ít phút để nhận liên kết xác nhận và kích hoạt tài khoản của bạn</p>

									{/* <label
										data-v-f99ecb42="" htmlFor="md-input-3037ci4xp" className='text-white font-16'></label> */}
									{/* <input data-v-f99ecb42="" value={email} onKeyPress={this.onKeyPress} onChange={this.onChangeInput('email')} type="text" aria-autocomplete="false"
										autoComplete="off" id="md-input-3037ci4xp" className="md-input background-2F3241" />
									<small className="md-error" /> */}
								</div>
								{countDown > 0 ? (<button style={{ marginTop: '1rem' }} data-v-f99ecb42="" type='button' disabled={countDown > 0}
									className={'w-100 ' + (isDisableSignButton ? 'btn-secondary btn' : 'btnheader log-in-under d-flex justify-content-center align-items-center text-white font-16')}>00:{countDown}
								</button>) : (
									<button style={{ marginTop: '1rem' }} data-v-f99ecb42="" type='button' onClick={this.sendEmail}
										className={'w-100 ' + (isDisableSignButton ? 'btn-secondary btn' : 'btnheader log-in-under d-flex justify-content-center align-items-center text-white font-16')}>Yêu cầu 1 email mới
									</button>
								)}
								{/* <p className='mt-5'>
									<span className='text-text'>Không nhận được Email xác thực?</span>
									<span className='colorBlue4'>Gửi lại</span>
								</p> */}
							</form>}
							{is_email_send && is_verify === 1 && <form style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }} className='loginForm position-absolute w-100 d-flex flex-column align-items-center justify-content-center h-100 colorWhite'>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={104}
									height={70}
									fill="none"
								>
									<path
										fill="url(#a)"
										fillRule="evenodd"
										d="M103.428 70c0-28.403-23.025-51.429-51.428-51.429S.57 41.597.57 70h102.857Z"
										clipRule="evenodd"
										opacity={0.1}
									/>
									<mask
										id="b"
										width={70}
										height={70}
										x={17}
										y={0}
										maskUnits="userSpaceOnUse"
										style={{
											maskType: "luminance",
										}}
									>
										<path fill="#fff" d="M17 0h70v70H17V0Z" />
									</mask>
									<g fill="#30E0A1" fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
										<path d="M17 35c0 19.33 15.67 35 35 35s35-15.67 35-35S71.33 0 52 0 17 15.67 17 35Zm35 32.95c-18.197 0-32.95-14.753-32.95-32.95C19.05 16.803 33.804 2.05 52 2.05c18.197 0 32.95 14.753 32.95 32.95 0 18.197-14.753 32.95-32.95 32.95Z" />
										<path d="M32.993 58.244A29.905 29.905 0 0 0 52 65.024c16.582 0 30.025-13.442 30.025-30.024S68.582 4.975 52 4.975 21.976 18.418 21.976 35a29.912 29.912 0 0 0 7.273 19.593 1.026 1.026 0 0 0 1.554-1.339A27.86 27.86 0 0 1 24.026 35C24.026 19.55 36.551 7.026 52 7.026 67.45 7.026 79.974 19.55 79.974 35c0 15.45-12.524 27.974-27.974 27.974a27.855 27.855 0 0 1-17.708-6.317 1.025 1.025 0 1 0-1.299 1.587Z" />
										<path d="M50.305 46.956a3.999 3.999 0 0 1-5.655 0l-9.467-9.467a1.76 1.76 0 0 1 0-2.487l3.695-3.695a1.759 1.759 0 0 1 2.487 0l5.66 5.659c.4.4 1.05.4 1.45 0l14.431-14.431a1.759 1.759 0 0 1 2.488 0l3.422 3.422a1.76 1.76 0 0 1 0 2.488l-12.36 12.36a1.025 1.025 0 0 0 1.45 1.45l12.36-12.36a3.81 3.81 0 0 0 0-5.388l-3.422-3.422a3.81 3.81 0 0 0-5.388 0L47.75 34.79l-4.934-4.934a3.81 3.81 0 0 0-5.388 0l-3.695 3.695a3.81 3.81 0 0 0 0 5.387l9.467 9.467a6.05 6.05 0 0 0 8.555 0l2.733-2.734a1.025 1.025 0 0 0-1.45-1.45l-2.733 2.734Z" />
										<path d="M44.447 39.544c.4.4 1.05.4 1.45 0l2.578-2.578a1.025 1.025 0 1 0-1.45-1.45l-2.578 2.578c-.4.4-.4 1.05 0 1.45Z" />
									</g>
									<defs>
										<linearGradient
											id="a"
											x1={52}
											x2={52}
											y1={18.571}
											y2={70}
											gradientUnits="userSpaceOnUse"
										>
											<stop stopColor="#30E0A1" />
											<stop offset={1} stopColor="#30E0A1" stopOpacity={0} />
										</linearGradient>
									</defs>
								</svg>
								<h2 className={`mt-5 color-white font-weight-bold mb-lg-5 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>Kích hoạt tài khoản thành công</h2>
							</form>}
							<p data-v-682ccdfa="" className="text-text text-left position-lg-absolute mt-lg-4 mt-3 bottom-1rem">
								{t('HaveAnAccount')}
								<a data-v-682ccdfa="" href="#" onClick={navigateTo('login').bind(this)} className="colorBlue4">{t('LoginToYourAccount')} </a>
							</p>
						</div>
					</div>

					<div data-v-682ccdfa="" tabIndex="-1" role="dialog" aria-hidden="true"
						className="modal fade">
						<div className="modal-dialog">
							<div className="modal-content">
								<div className="panel" />
							</div>
						</div>
					</div>
				</div>
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer
	};
}
const withSnackbar = (Component) => (props) => {
	const { enqueueSnackbar } = useSnackbar();
	return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
	fetchingUserSuccess,
	updateAppConfigAction,

})(withRouter(withTranslation()(withSnackbar(Register))));
